import React, { memo, useMemo } from 'react'
import dynamic from 'next/dynamic'

const customSubmitTypes = {
	paypalButton: dynamic(() => import('root/src/client/web/base/CustomButton/PayPalButton')),
	paypalSubscriptionButton: dynamic(() => import('root/src/client/web/base/CustomButton/PayPalSubscriptionButton')),
	providerButtons: dynamic(() => import('root/src/client/v2/auth/components/SignInWithProviderButtons').then(module => module.SignInWithProviderButtons)),
}

export const SubmitsUnstyled = memo(({
	customSubmitType, customSubmitsData, customPayPalAction, promotionAction, submitIndex, componentProps,
}) => {
	const CustomSubmitComponent = useMemo(() => customSubmitTypes[customSubmitType],
		[customSubmitTypes, customSubmitType])

	if (!CustomSubmitComponent) {
		return null
	}

	return (
		<CustomSubmitComponent
			key={`${submitIndex}-custom`}
			customSubmitsData={customSubmitsData}
			submitIndex={submitIndex}
			customPayPalAction={customPayPalAction}
			promotionAction={promotionAction}
			{...componentProps}
		/>
	)
})

export default SubmitsUnstyled
